import posthog from 'posthog-js'

const { VITE_POSTHOG_API_KEY, VITE_POSTHOG_HOST, VITE_ENABLE_LOCAL_ANALYTICS } = import.meta.env

const POSTHOG_API_KEY = VITE_POSTHOG_API_KEY
const POSTHOG_HOST: string = VITE_POSTHOG_HOST || 'https://eu.i.posthog.com'
const ENABLE_LOCAL_ANALYTICS = VITE_ENABLE_LOCAL_ANALYTICS === 'true' || VITE_ENABLE_LOCAL_ANALYTICS === '1'

function isLocalhost() {
  return window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
}

const isEnabled = POSTHOG_API_KEY && POSTHOG_HOST && (isLocalhost() ? ENABLE_LOCAL_ANALYTICS : true)

let initialized = false

export function initAnalytics() {
  if (!isEnabled || initialized) return

  posthog.init(POSTHOG_API_KEY, {
    api_host: POSTHOG_HOST,
    autocapture: false,
    capture_pageview: false,
    capture_pageleave: false,
    persistence: 'memory', // web player runs on public screens, no need for persistent storage
  })

  initialized = true
}

export function track(eventName: string, properties?: Record<string, any>) {
  if (!isEnabled) return
  posthog.capture(eventName, properties)
}
